import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import propTypes, { __deprecatedMapping, getStyleSheetPropType } from './propTypes';
import getChildContextFromProps from './getChildContext';
export var StyleSheetOverridesContext = /*#__PURE__*/React.createContext({});
export var StyleSheetOverridesConsumer = StyleSheetOverridesContext.Consumer;
export var useStyleSheetOverrides = function useStyleSheetOverrides() {
  return React.useContext(StyleSheetOverridesContext);
};

var StyleSheetOverridesProvider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(StyleSheetOverridesProvider, _React$PureComponent);

  var _super = _createSuper(StyleSheetOverridesProvider);

  function StyleSheetOverridesProvider() {
    _classCallCheck(this, StyleSheetOverridesProvider);

    return _super.apply(this, arguments);
  }

  _createClass(StyleSheetOverridesProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return getChildContextFromProps(propTypes, __deprecatedMapping)(this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _getChildContextFromP = getChildContextFromProps(propTypes, __deprecatedMapping)(this.props),
          getStyleSheet = _getChildContextFromP.getStyleSheet;

      return /*#__PURE__*/React.createElement(StyleSheetOverridesContext.Provider, {
        value: getStyleSheet
      }, this.props.children);
    }
  }]);

  return StyleSheetOverridesProvider;
}(React.PureComponent);

StyleSheetOverridesProvider.displayName = 'StyleSheetOverridesProvider';
StyleSheetOverridesProvider.defaultProps = {};
StyleSheetOverridesProvider.propTypes = propTypes;
StyleSheetOverridesProvider.childContextTypes = {
  getStyleSheet: getStyleSheetPropType
};
export default StyleSheetOverridesProvider;
//# sourceMappingURL=index.js.map